import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Chat Stroke
 */

export default function ChatStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M3.3549 2.97189C2.18335 3.87212 1.5 5.08099 1.5 6.37883C1.5 8.25429 2.94305 9.96554 5.19564 10.7791C5.58689 10.9204 5.875 11.2919 5.875 11.7348V14.4785L8.25221 11.5725C8.42513 11.3611 8.67229 11.2357 8.93059 11.2078C12.1897 10.8554 14.5 8.73793 14.5 6.37883C14.5 5.08099 13.8166 3.87212 12.6451 2.97189C11.473 2.07126 9.8324 1.5 8 1.5C6.1676 1.5 4.52698 2.07126 3.3549 2.97189ZM2.7456 2.17895C4.10703 1.13283 5.9664 0.5 8 0.5C10.0336 0.5 11.893 1.13283 13.2544 2.17895C14.6164 3.22548 15.5 4.70602 15.5 6.37883C15.5 9.44757 12.5789 11.8191 9.0381 12.202C9.02984 12.2029 9.02632 12.2057 9.02586 12.2061L6.64902 15.1117C6.05395 15.8391 4.875 15.4183 4.875 14.4785V11.735C4.87485 11.7346 4.87437 11.7335 4.87319 11.7319C4.87023 11.7278 4.86451 11.7228 4.85594 11.7197C2.35085 10.8149 0.5 8.81032 0.5 6.37883C0.5 4.70602 1.38365 3.22548 2.7456 2.17895Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
